import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Label } from "@progress/kendo-react-labels";
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import APIConnector from "../../../../apiconnector";
import CommonVariables from "../../../../variables";
import Notifications from "../../../../Notifications/Messages";
import { dynamicSpinner, PdfDownload } from "../../../../commonfunctions";
const EditQuoteRequest = (props) => {
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const quoteRequestId = props.obj?.id || props.obj?.Id || "";
    const normalizedQuoteRequestId = quoteRequestId ? quoteRequestId.toString().trim().toLowerCase() : "";
    const isCreateMode =
        props.isCreateMode === true
        || props.mode === "add"
        || props.obj?.isCreateMode === true
        || normalizedQuoteRequestId === emptyGuid
        || (!quoteRequestId && props.title === "Add Quote Request");
    const shouldLoadAttachments = !isCreateMode && !props.disableAttachmentLoad;
    const maxAttachmentSizeInBytes = 5 * 1024 * 1024;
    const allowedAttachmentExtensions = ["pdf", "xlsx", "txt"];
    const requestTypeDropdown = [
        { text: "Quote", value: "Quote" },
        { text: "Re-Quote", value: "ReQuote" },
        { text: "Revision", value: "Revision" },
        { text: "Revision-New List", value: "RevisionNewList" }
    ];
    const Statusdropdown = [
        { text: "Open/Unassigned", statusValue: "Open/Unassigned", statusId: "OpenUnassigned", status: 0 },
        { text: "InProgress/Assigned", statusValue: "InProgress/Assigned", statusId: "InProgressAssigned", status: 1 },
        { text: "Completed", statusValue: "Completed", statusId: "Completed", status: 2 }
    ];
    const parseDateValue = (value) => {
        if (!value) {
            return null;
        }
        if (value instanceof Date) {
            return isNaN(value.getTime()) ? null : value;
        }
        const parsedDate = new Date(value);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
    };
    const normalizeCompareValue = (value) => {
        return value ? value.toString().trim().toLowerCase() : "";
    };
    const getSelectedRequestTypeOption = (requestType) => {
        return requestTypeDropdown.find((option) => option.value === requestType || option.text === requestType) || null;
    };
    const mapStatusValueToStatusOption = (statusValue) => {
        return Statusdropdown.find((option) => option.statusValue === statusValue) || null;
    };
    const [files, setFiles] = React.useState([]);
    const [loadingQAfiles, setLoadingQAFiles] = React.useState(shouldLoadAttachments);
    const [accountOptions, setAccountOptions] = React.useState([]);
    const [accountSearchText, setAccountSearchText] = React.useState("");
    const [accountLookupOpen, setAccountLookupOpen] = React.useState(false);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [selectedAttachments, setSelectedAttachments] = React.useState([]);
    const [dialogDimension, setDialogDimension] = React.useState([]);
    const [currentUser, setCurrentUser] = React.useState(null);
const [rowitem, setRowItem] = React.useState({
        accountName: props.obj?.accountName || "",
        accountNumber: props.obj?.accountNumber || "",
        accountId: props.obj?.accountId || "",
        createdby: props.obj?.createdby || "",
        requestingUserId: props.obj?.requestingUserId || "",
        requestDate: parseDateValue(props.obj?.requestDate) || new Date(),
        requestType: isCreateMode
            ? getSelectedRequestTypeOption(props.obj?.requestType || "") || requestTypeDropdown[0]
            : getSelectedRequestTypeOption(props.obj?.requestType || "")
                || { text: props.obj?.requestType ?? "", value: props.obj?.requestType ?? "" },
        extAssignedId: props.obj?.tt_ExtAssigneeId || "",
        extAssignedIdName: props.obj?.extAssignedIdName || "",
        statusValue: isCreateMode
            ? Statusdropdown[0]
            : mapStatusValueToStatusOption(props.obj?.statusValue) || Statusdropdown[0],
        needbydate: parseDateValue(props.obj?.needbydate) || new Date(),
        assignDate: parseDateValue(props.obj?.tt_AssignedDate) || null,
        completionDate: parseDateValue(props.obj?.tt_CompletionDate) || null,
        specialNotes: props.obj?.specialNotes || "",
        responseNotes: props.obj?.responseNotes || ""
    });
    const loadCurrentUser = () => {
        const currentUserId = CommonVariables.getlocalstorageData().userId;
        if (!currentUserId) {
            return;
        }
        APIConnector.Post(CommonVariables.urls.getUserById, { id: currentUserId }).then(function (response) {
            if (!CommonVariables.isError(response)) {
                return;
            }
            const currentUser = Array.isArray(response) ? response[0] : response;
            const currentUserFullName  = `${currentUser?.firstName || ""} ${currentUser?.lastName || ""}`.trim();
            setCurrentUser(currentUserFullName);
            setRowItem((previousRowItem) => ({
                ...previousRowItem,
                requestingUserId: response.systemUserId,
                createdby: currentUserFullName
            }));
            clearValidationError("requestingUserId");
        });
    };
    const requiredValidator = (value, message) => {
        if (value === null || value === undefined) {
            return message;
        }
        if (value instanceof Date) {
            return isNaN(value.getTime()) ? message : "";
        }
        if (typeof value === "string" && !value.trim()) {
            return message;
        }
        if (typeof value === "object") {
            if (Object.keys(value).length === 0) {
                return message;
            }
            if ("value" in value && !value.value) {
                return message;
            }
            if ("statusValue" in value && !value.statusValue) {
                return message;
            }
            if ("id" in value && !value.id) {
                return message;
            }
        }
        return "";
    };
    const  renderRequiredAsterisk = () => {
        return <span style={{ color: "#d51923" }}>*</span>;
    };
    const renderValidationError = (fieldName) => {
        if (!validationErrors[fieldName]) {
            return null;
        }
        return (
            <div style={{ color: "#d51923", fontSize: "12px", fontWeight: "bold", marginTop: "4px" }}>
                {validationErrors[fieldName]}
            </div>
        );
    };
    const clearValidationError = (fieldName) => {
        setValidationErrors((previousErrors) => ({
            ...previousErrors,
            [fieldName]: ""
        }));
    };
    const validateQuoteRequestForm = (formValues) => {
        const errors = {
            accountNumber: requiredValidator(rowitem.accountId || rowitem.accountName, "Account is required."),
            requestType: requiredValidator(formValues.requestType?.value || formValues.requestType, "Request Type is required."),
            requestingUserId: requiredValidator(rowitem.requestingUserId, "Requesting User is required."),
            statusValue: requiredValidator(formValues.statusValue?.statusValue || formValues.statusValue, "Status is required."),
            requestDate: requiredValidator(rowitem.requestDate || formValues.requestDate, "Request Date is required.")
        };
        setValidationErrors(errors);
        const hasValidationErrors = Object.values(errors).some((errorMessage) => errorMessage);
        if (hasValidationErrors) {
            Notifications.ShowWarningMessage("Please fill all required fields.");
        }
        return !hasValidationErrors;
    };
    const getFormValue = (formRenderProps, fieldName, fallbackValue = "") => {
        if (formRenderProps && typeof formRenderProps.valueGetter === "function") {
            const fieldValue = formRenderProps.valueGetter(fieldName);
            return fieldValue !== undefined ? fieldValue : fallbackValue;
        }
        return fallbackValue;
    };
    const handleSaveClick = (formRenderProps) => {
        const formValues = {
            accountId: rowitem.accountId || "",
            accountNumber: rowitem.accountNumber || "",
            accountName: rowitem.accountName || "",
            requestingUserId: rowitem.requestingUserId || "",
            createdby: rowitem.createdby || "",
            requestDate: rowitem.requestDate || new Date(),
            requestType: rowitem.requestType,
            tt_extAssignedId: rowitem.extAssignedId || "",
            statusValue: rowitem.statusValue,
            statusId: rowitem.statusValue?.statusValue || "",
            status: rowitem.statusValue?.status ?? 0,
            needbydate: rowitem.needbydate,
            tt_AssignedDate: rowitem.assignDate,
            tt_CompletionDate: rowitem.completionDate,
            specialNotes: getFormValue(formRenderProps, "specialNotes", rowitem.specialNotes),
            responseNotes: getFormValue(formRenderProps, "responseNotes", rowitem.responseNotes),
            attachments: selectedAttachments
        };
        if (!validateQuoteRequestForm(formValues)) {
            return;
        }
        props.onSubmit({
            ...formValues,
            requestType: formValues.requestType?.value || formValues.requestType || "",
            attachments: selectedAttachments
        });
    };
    const getFileExtension = (fileName) => {
        if (!fileName || fileName.indexOf(".") === -1) {
            return "";
        }
        return fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    };
    const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result || "";
                const base64Body = result.toString().includes(",")
                    ? result.toString().split(",")[1]
                    : result.toString();
                resolve(base64Body);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const handleAttachmentChange = async (event) => {
        const fileList = Array.from(event.target.files || []);
        if (fileList.length <= 0) {
            return;
        }
        const invalidTypeFiles = fileList.filter((file) => {
            const extension = getFileExtension(file.name);
            return !allowedAttachmentExtensions.includes(extension);
        });
        if (invalidTypeFiles.length > 0) {
            Notifications.ShowWarningMessage("Only PDF, XLSX, and TXT files are allowed.");
            event.target.value = "";
            setSelectedAttachments([]);
            return;
        }
        const invalidSizeFiles = fileList.filter((file) => file.size > maxAttachmentSizeInBytes);
        if (invalidSizeFiles.length > 0) {
            Notifications.ShowWarningMessage("Attachment file size should not exceed 5 MB.");
            event.target.value = "";
            setSelectedAttachments([]);
            return;
        }
        const attachmentModels = await Promise.all(fileList.map(async (file) => ({
            Id: "00000000-0000-0000-0000-000000000000",
            RegardingObjectId: "00000000-0000-0000-0000-000000000000",
            TitleFileName: file.name,
            RegardingObjectType: "tt_quoterequest",
            MimeType: file.type || "application/octet-stream",
            FileType: getFileExtension(file.name),
            FileBody: await readFileAsBase64(file),
            CreatedOn: null,
            CreatedBy: null,
            ModifiedOn: null,
            ModifiedBy: null
        })));
        setSelectedAttachments(attachmentModels);
        event.target.value = "";
    };
    const removeSelectedAttachment = (indexToRemove) => {
        setSelectedAttachments((previousAttachments) =>
            previousAttachments.filter((_, index) => index !== indexToRemove)
        );
    };
    const deleteExistingAttachment = (attachment) => {
        const attachmentId = attachment?.recordId;
        if (!attachmentId) {
            Notifications.ShowErrorMessage("Attachment Id was not found.");
            return;
        }
        const deleteAttachmentUrl = CommonVariables.urls.RemoveAttachmentFromQuote;
        if (!deleteAttachmentUrl) {
            Notifications.ShowErrorMessage("RemoveAttachmentFromQuote API URL is not configured.");
            return;
        }
        props.onLoaderRaise(true, "Deleting attachment ...", { marginTop: "145px" });
        APIConnector.Post(deleteAttachmentUrl, { Id: attachmentId, RecordId: attachmentId }).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response)) {
                return;
            }
            if (response === true || response?.isSuccess) {
                setFiles((previousFiles) =>
                    previousFiles.filter((file) => file.recordId !== attachmentId)
                );
                Notifications.ShowSuccessMessage("Attachment deleted successfully.");
            }
            else {
                Notifications.ShowErrorMessage("Something went wrong. Please try again.");
            }
        });
    };
    const normalizeAccountOptions = (accounts) => {
        if (!Array.isArray(accounts)) {
            return [];
        }
        return accounts.map((account) => ({
            accountId: account.accountId || "",
            accountNumber: account.accountnumber || "",
            accountName: account.name || ""
        }));
    };
    const loadAccounts = () => {
        if (accountOptions.length > 0) {
            setAccountLookupOpen(true);
            return;
        }
        props.onLoaderRaise(true, "Loading accounts ...", { marginTop: "145px" });
        APIConnector.Get(CommonVariables.urls.GetAllAccounts).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response)) {
                return;
            }
            setAccountOptions(normalizeAccountOptions(response));
            setAccountLookupOpen(true);
        });
    };
    const selectAccount = (accountItem) => {
        const selectedAccountId = accountItem.accountId || "";
        setRowItem((previousRowItem) => ({
            ...previousRowItem,
            accountId: selectedAccountId,
            accountNumber: accountItem.accountNumber || "",
            accountName: accountItem.accountName || ""
        }));
        clearValidationError("accountNumber");
        setAccountSearchText("");
        setAccountLookupOpen(false);
    };
    React.useEffect(() => {
        if (isCreateMode) {
            loadCurrentUser();
        }
if (shouldLoadAttachments) {
            APIConnector.Post(CommonVariables.urls.GetQuoteQueueAttachmentListById, { id: props.obj.id }).then(function (response) {
                if (!CommonVariables.isError(response)) {
                    setLoadingQAFiles(false);
                    return;
                }
                if (response && response.length > 0) {
                    setFiles(response);
                }
                setLoadingQAFiles(false);
            });
        }
        else {
            setFiles([]);
            setLoadingQAFiles(false);
        }
        const neededheight = Math.min(window.innerHeight - 80, 820);
        const neededwidth = Math.min(window.innerWidth - 48, 1040);
        setDialogDimension([neededheight, neededwidth]);
    }, []);
    const filteredAccountOptions = accountOptions.filter((account) => {
        const searchValue = accountSearchText.toString().trim().toLowerCase();
        if (!searchValue) {
            return true;
        }
        return (account.accountName || "").toLowerCase().includes(searchValue)
            || (account.accountNumber || "").toLowerCase().includes(searchValue);
    });
    const renderLookupPopup = (title, gridData, columns, onClose) => {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.35)",
                    zIndex: 10000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <div
                    style={{
                        width: "500px",
                        height: "800px",
                        maxWidth: "500px",
                        maxHeight: "800px",
                        backgroundColor: "#ffffff",
                        borderRadius: "6px",
                        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden"
                    }}
                >
                    <div
                        style={{
                            padding: "12px 16px",
                            borderBottom: "1px solid #d9d9d9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontWeight: "bold"
                        }}
                    >
                        <span>{title}</span>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                border: "none",
                                backgroundColor: "transparent",
                                cursor: "pointer",
                                fontSize: "18px",
                                lineHeight: "18px"
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <div style={{ padding: "12px", flex: 1, overflow: "hidden" }}>
                        <Grid
                            className="rounded-2xl border-b-4"
                            data={gridData}
                            sortable={true}
                            pageable={true}
                            resizable={true}
                            style={{ height: "720px" }}
                        >
                            {columns}
                        </Grid>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <Dialog title={props.title || (isCreateMode ? "Add Quote Request" : "Edit Quote Request")} onClose={props.cancelEdit} height={dialogDimension[0]} width={dialogDimension[1]}>
            <div>
                <Form
                    className="rounded-t-2xl w-screen flex"
                    key={`${isCreateMode}-${rowitem.requestingUserId}-${rowitem.accountNumber}-${rowitem.accountName}-${rowitem.extAssignedId}`}
                    initialValues={rowitem}
                    onSubmit={() => { }}
                    render={(formRenderProps) => (
                        <FormElement className="quote-modal rounded-t-2xl font-normal w-full">
                            <fieldset className="k-form-fieldset grid md:grid-cols-4 gap-2">
                                <div>
                                    <label className="fieldlabel">Account {renderRequiredAsterisk()}</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <Input value={rowitem.accountNumber} disabled={true} />
                                        {isCreateMode && (
                                            <button
                                                type="button"
                                                title="Search Account"
                                                onClick={loadAccounts}
                                                style={{
                                                    height: "32px",
                                                    minWidth: "34px",
                                                    border: "1px solid #8b96c7",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#ebefff",
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                            >
                                                <SearchIcon style={{ color: "#5454ec", fontSize: "18px" }} />
                                            </button>
                                        )}
                                    </div>
                                    {renderValidationError("accountNumber")}
                                </div>
                                <div>
                                    <label className="fieldlabel">Requesting User {renderRequiredAsterisk()}</label>
                                    <Input value={rowitem.createdby || currentUser } disabled={true} />
                                    {renderValidationError("requestingUserId")}
                                </div>
                                <div>
                                    <label className="fieldlabel">Request date {renderRequiredAsterisk()}</label>
                                    <DatePicker value={rowitem.requestDate || new Date()} disabled={true} />
                                    {renderValidationError("requestDate")}
                                </div>
                                <div>
                                    <label className="fieldlabel">Request type {renderRequiredAsterisk()}</label>
                                    <DropDownList
                                        data={isCreateMode ? requestTypeDropdown : [rowitem.requestType]}
                                        textField="text"
                                        dataItemKey="value"
                                        disabled={!isCreateMode}
                                        value={rowitem.requestType}
                                        defaultItem={{ text: "Select Request Type", value: "" }}
                                        onChange={(e) => {
                                            setRowItem((previousRowItem) => ({
                                                ...previousRowItem,
                                                requestType: e.value
                                            }));
                                            clearValidationError("requestType");
                                        }}
                                    />
                                    {renderValidationError("requestType")}
                                </div>
                                <div>
                                    <label className="fieldlabel">Status {renderRequiredAsterisk()}</label>
                                    <DropDownList
                                        data={Statusdropdown}
                                        textField="text"
                                        dataItemKey="statusValue"
                                        value={isCreateMode ? Statusdropdown[0] : rowitem.statusValue}
                                        disabled={isCreateMode}
                                        onChange={(e) => {
                                            setRowItem((previousRowItem) => ({
                                                ...previousRowItem,
                                                statusValue: e.value
                                            }));
                                            clearValidationError("statusValue");
                                        }}
                                    />
                                    {renderValidationError("statusValue")}
                                </div>
                                <div>
                                    <label className="fieldlabel">Need by date</label>
                                    <DatePicker
                                        value={rowitem.needbydate}
                                        onChange={(e) => {
                                            setRowItem((previousRowItem) => ({
                                                ...previousRowItem,
                                                needbydate: e.value
                                            }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="fieldlabel">Assign date</label>
                                    <DatePicker
                                        value={rowitem.assignDate}
                                        onChange={(e) => {
                                            setRowItem((previousRowItem) => ({
                                                ...previousRowItem,
                                                assignDate: e.value
                                            }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="fieldlabel">Completion date</label>
                                    <DatePicker
                                        value={rowitem.completionDate}
                                        onChange={(e) => {
                                            setRowItem((previousRowItem) => ({
                                                ...previousRowItem,
                                                completionDate: e.value
                                            }));
                                        }}
                                    />
                                </div>
                            </fieldset>
                            <fieldset className="k-form-fieldset grid grid-cols-1 md\\\:grid-cols-2 gap-6">
                                <div className="mb-3">
                                    <Label className="fieldlabel">Request Notes</Label>
                                    <Field name={"specialNotes"} component={TextArea} autoSize />
                                </div>
                                <div className="mb-3">
                                    <Label className="fieldlabel">Response Notes</Label>
                                    <Field name={"responseNotes"} component={TextArea} />
                                </div>
                            </fieldset>
                            <fieldset className="k-form-fieldset">
                                <div className="mb-3">
                                    <Label className="fieldlabel">Upload Attachments</Label>
                                    <input
                                        type="file"
                                        multiple={true}
                                        accept=".pdf,.xlsx,.txt"
                                        onChange={handleAttachmentChange}
                                    />
                                    <div style={{ fontSize: "12px", marginTop: "4px" }}>
                                        Only PDF, XLSX, and TXT files are allowed. Maximum file size allowed: 5 MB.
                                    </div>
                                    {selectedAttachments.length > 0 && (
                                        <div
                                            style={{
                                                marginTop: "8px",
                                                display: "flex",
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                gap: "10px"
                                            }}
                                        >
                                            {selectedAttachments.map((file, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        border: "1px solid #d9d9d9",
                                                        borderRadius: "4px",
                                                        padding: "6px 8px",
                                                        maxWidth: "360px"
                                                    }}
                                                >
                                                    <span
                                                        title={file.TitleFileName}
                                                        style={{
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            maxWidth: "220px"
                                                        }}
                                                    >
                                                        {file.TitleFileName}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        onClick={() => removeSelectedAttachment(index)}
                                                        title="Remove selected attachment"
                                                        style={{
                                                            border: "1px solid #d51923",
                                                            borderRadius: "4px",
                                                            backgroundColor: "#ffffff",
                                                            color: "#d51923",
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: "3px",
                                                            padding: "3px 6px",
                                                            fontSize: "12px",
                                                            lineHeight: "16px"
                                                        }}
                                                    >
                                                        <DeleteIcon style={{ fontSize: "16px" }} />
                                                        Delete
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </fieldset>
                            {shouldLoadAttachments && (
                                <>
                                    <Label className="fieldlabel">Attachments</Label>
                                    <div
                                        className="sok-tile-row"
                                        style={{
                                            border: "2px solid",
                                            borderColor: "#b4b1b1",
                                            height: "auto",
                                            minHeight: "52px",
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                            gap: "10px",
                                            padding: "8px"
                                        }}
                                    >
                                        {loadingQAfiles && dynamicSpinner({ width: "80px", height: "80px", marginTop: "31px", marginLeft: "12px" })}
                                        {!loadingQAfiles && files.length <= 0 && <div style={{ textAlign: "center", width: "100%" }}><label>No Attachments available</label></div>}
                                        {!loadingQAfiles && files.length > 0 && files.map((eachFile, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    border: "1px solid #d9d9d9",
                                                    borderRadius: "4px",
                                                    padding: "6px 8px",
                                                    maxWidth: "360px"
                                                }}
                                            >
                                                <DownloadIcon style={{ fontSize: "18px" }} />
                                                <span
                                                    title={eachFile.fileNmae}
                                                    onClick={() => { PdfDownload(eachFile.fileNmae, eachFile.documentBody || eachFile.FileBody || eachFile.fileBody) }}
                                                    style={{
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "220px"
                                                    }}
                                                >
                                                    {eachFile.fileNmae}
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={() => deleteExistingAttachment(eachFile)}
                                                    title="Delete Attachment"
                                                    style={{
                                                        border: "1px solid #d51923",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#ffffff",
                                                        color: "#d51923",
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                        padding: "3px 6px",
                                                        fontSize: "12px",
                                                        lineHeight: "16px"
                                                    }}
                                                >
                                                    <DeleteIcon style={{ fontSize: "16px" }} />
                                                    Delete
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                            <div className="k-form-buttons">
                                <button type="button" className="button-save" onClick={() => handleSaveClick(formRenderProps)}>
                                    {isCreateMode ? "Add" : "Update"}
                                </button>
                                <button type="button" className="button-cancel" onClick={() => props.cancelEdit()}>
                                    Cancel
                                </button>
                            </div>
                        </FormElement>
                    )}
                />
            </div>
            {accountLookupOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.35)",
                        zIndex: 10000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div
                        style={{
                            width: "500px",
                            height: "800px",
                            maxWidth: "500px",
                            maxHeight: "800px",
                            backgroundColor: "#ffffff",
                            borderRadius: "6px",
                            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden"
                        }}
                    >
                        <div
                            style={{
                                padding: "12px 16px",
                                borderBottom: "1px solid #d9d9d9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                fontWeight: "bold"
                            }}
                        >
                            <span>Select Account</span>
                            <button
                                type="button"
                                onClick={() => {
                                    setAccountSearchText("");
                                    setAccountLookupOpen(false);
                                }}
                                style={{
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    lineHeight: "18px"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div style={{ padding: "12px 12px 6px 12px" }}>
                            <Input
                                placeholder="Search accounts by name or number"
                                value={accountSearchText}
                                onChange={(event) => setAccountSearchText(event.value || "")}
                            />
                        </div>
                        <div style={{ padding: "6px 12px 12px 12px", flex: 1, overflow: "hidden" }}>
                            <Grid
                                className="rounded-2xl border-b-4"
                                data={filteredAccountOptions}
                                sortable={true}
                                pageable={true}
                                resizable={true}
                                style={{ height: "680px" }}
                            >
                                <GridColumn field="accountNumber" title="Account No." width="150" />
                                <GridColumn field="accountName" title="Account Name" />
                                <GridColumn
                                    title="Select"
                                    width="90"
                                    cell={(accountCellProps) => (
                                        <td>
                                            <button
                                                type="button"
                                                className="button-save"
                                                onMouseDown={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                }}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    selectAccount(accountCellProps.dataItem);
                                                }}
                                            >
                                                Select
                                            </button>
                                        </td>
                                    )}
                                />
                            </Grid>
                        </div>
                    </div>
                </div>
            )}
        </Dialog>
    );
};
export default EditQuoteRequest;
